import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import * as CalendarSaga from './Saga/Calendar';
import Meetings from '../Meetings/Index';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, FormLabel, FormGroup, Button, IconButton, Radio, RadioGroup, ListItemIcon, ListItemSecondaryAction } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import OwnerSearchIndex from "./OwnerSearchIndex";
import MaskedInput from 'react-text-mask';
import DateTimeComponentTime from "./DateTimeComponentTime";
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Fab from '@mui/material/Fab';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import './Css/Calendar.css';
import GroupSelectUser from "./GroupSelectUser";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckIcon from '@mui/icons-material/Check';



var moment = require('moment-timezone');




 
class GroupEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kashikata: false,

            columnWidths:{
                id:80,
                name:200,
            },
            setDragIndex:null,
            sort_mode:true,

            detail: {id: 0, name: "", is_default: false},

            columnWidthsUser:{
                id:80,
                user_name_all:200,
            },
            setDragIndexUser:null,
            sort_modeUser:true,

            section_id: 0,
            del_id: 0,

            showPopup:false,
        };

        this._rowClassNameGetter = this._rowClassNameGetter.bind(this);
        this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
        // this._rowClassNameGetterUser = this._rowClassNameGetterUser.bind(this);
        this._onColumnResizeEndCallbackUser = this._onColumnResizeEndCallbackUser.bind(this);
        this.handleNewGroup = this.handleNewGroup.bind(this);

        this.props.get_calendar_group_list()

    }


    dragStart(index){
        if(this.state.sort_mode){
            // alert(index)
            this.setState({ setDragIndex: index })
        }
    }


    dragEnter(index){

        if(this.state.sort_mode){

        if (index === this.state.setDragIndex) return;


        let calendar_group_list = JSON.parse(JSON.stringify(this.props.calendar_group_list));
        const deleteElement = calendar_group_list.splice(this.state.setDragIndex, 1)[0];
        calendar_group_list.splice(index, 0, deleteElement);


        this.props.change_calendar_group_list(calendar_group_list)

        this.setState({ setDragIndex: index })
        }
    }

    dragEnd(){
        // alert("hozon")
        if(this.state.sort_mode){
            this.setState({ setDragIndex: null })
        }
    }

    _rowClassNameGetter(index){
        
        if(this.props.calendar_group_list && this.props.calendar_group_list[index]){

            if(this.props.calendar_group_list[index].id == this.state.detail.id){
                return "select"
            }else{
                return "normal"
            }
        }else{
            return ""
        }
    }

    _onColumnResizeEndCallback(newColumnWidth, columnKey) {
        this.setState(({ columnWidths }) => ({
          columnWidths: {
            ...columnWidths,
            [columnKey]: newColumnWidth,
          },
        }));
    }

    dragStartUser(index){
        if(this.state.sort_mode){
            // alert(index)
            this.setState({ setDragIndex: index })
        }
    }

    dragEnterUser(index){

        if(this.state.sort_modeUser){

        if (index === this.state.setDragIndexUser) return;


        let calendar_group_user_list = JSON.parse(JSON.stringify(this.props.calendar_group_user_list));
        const deleteElement = calendar_group_user_list.splice(this.state.setDragIndexUser, 1)[0];
        calendar_group_user_list.splice(index, 0, deleteElement);


        this.props.change_calendar_group_user_list(calendar_group_user_list)

        this.setState({ setDragIndexUser: index })
        }
    }

    dragEndUser(){
        // alert("hozon")
        if(this.state.sort_modeUser){
            this.setState({ setDragIndexUser: null })
        }
    }

    _onColumnResizeEndCallbackUser(newColumnWidth, columnKey) {
        this.setState(({ columnWidthsUser }) => ({
          columnWidthsUser: {
            ...columnWidthsUser,
            [columnKey]: newColumnWidth,
          },
        }));
    }

    handleCellClick(index){
        this.setState({ detail: this.props.calendar_group_list[index]})

        this.props.get_calendar_group_user_list(this.props.calendar_group_list[index].id)
    }

    handleChange = (e) => {
        const { name, value, checked } = e.target;

        this.setState((prevState) => ({
            detail: {
            ...prevState.detail,
            [name]: e.target.name === "is_default" ? checked : value, // ← nameに対応するプロパティを更新
            },
        }));
    }

    handleChangeTenpo = (e) => {
        this.setState({ section_id: e.target.value})
    }

    handleNewGroup(){
        this.setState({ detail: {id: 0, name: "", is_default: false}})
    }

    handleUpdate = () => {

        // ポップアップ表示
        this.setState({ showPopup: true });

        if(this.state.detail.id == 0){
            //新規
            this.props.insert_m_calendar_groups(this.state.detail)
        }else{
            //更新
            this.props.update_m_calendar_groups(this.state.detail)
        }

        // 1秒後に非表示
        setTimeout(() => {
        this.setState({ showPopup: false });
        }, 1000);

    }

    onClickAddUser = (item) => {

        let calendar_group_user_list = [...this.props.calendar_group_user_list]

        //すでに選択済み
        if(calendar_group_user_list.filter(a=>a.id == item.id).length > 0){
            calendar_group_user_list = calendar_group_user_list.filter(a=>a.id != item.id)
        }else{
            calendar_group_user_list.push(item)
        }

        this.props.change_calendar_group_user_list(calendar_group_user_list)
    }

    handleSortUpdate = () => {
        // ポップアップ表示
        this.setState({ showPopup: true });

        this.props.update_m_calendar_groups_sort()

        // 1秒後に非表示
        setTimeout(() => {
        this.setState({ showPopup: false });
        }, 1000);
    }
    
    render() {
        return <Box display="flex" gap={2}>


                
                <Box>
                

                <Table
                    className="gridCalendarGroupList"
                    rowHeight={36}
                    rowsCount={this.props.calendar_group_list.length} 
                    width={340}
                    // height={150}
                    height={window.innerHeight - 390}
                    headerHeight={34}
                    onColumnResizeEndCallback={this._onColumnResizeEndCallback}
                    isColumnResizing={false}
                    rowClassNameGetter={this._rowClassNameGetter}
                    // onRowClick={this.RowClick}
                    
                >
    
                    <Column width={this.state.columnWidths.name} isResizable={true} columnKey="name" header={<Cell>グループ名</Cell>} cell={({ rowIndex, ...props }) => (<Cell 
                                // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                                onClick={()=>this.handleCellClick(rowIndex)}
                                draggable={true}
                                onDragStart={() => this.dragStart(rowIndex)}
                                onDragEnter={() => this.dragEnter(rowIndex)}
                                onDragOver={(event) => event.preventDefault()}
                                onDragEnd={() => this.dragEnd()}
                                className={rowIndex === this.state.setDragIndex ? 'dragging' : ''}
                    {...props}>
                        {this.props.calendar_group_list[rowIndex].name}
                    </Cell>)} />
                    <Column width={80} isResizable={false} header={<Cell>初期表示</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props}
                                            // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                                            draggable={true}
                                            onDragStart={() => this.dragStart(rowIndex)}
                                            onDragEnter={() => this.dragEnter(rowIndex)}
                                            onDragOver={(event) => event.preventDefault()}
                                            onDragEnd={() => this.dragEnd()}
                                            className={rowIndex === this.state.setDragIndex ? 'dragging' : ''}
                    >
                        {this.props.calendar_group_list[rowIndex].is_default ? <CheckIcon />:""}
                    </Cell>)} />
                    <Column width={60} isResizable={false} header={<Cell>削除</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props}
                                            // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                                            draggable={true}
                                            onDragStart={() => this.dragStart(rowIndex)}
                                            onDragEnter={() => this.dragEnter(rowIndex)}
                                            onDragOver={(event) => event.preventDefault()}
                                            onDragEnd={() => this.dragEnd()}
                                            className={rowIndex === this.state.setDragIndex ? 'dragging' : ''}
                    >
                        <IconButton
                            onClick={(e)=>{this.setState({ "del_id":this.props.calendar_group_list[rowIndex].id })}}
                            style={{padding:2}}
                            size="large"><DeleteIcon /></IconButton>
                    </Cell>)} />
    
                </Table>

                    <Button
                        size="small"
                        startIcon={<AddCircleIcon />}
                        onClick={this.handleNewGroup}
                        variant="contained"
                        style={{ marginRight: 5, marginTop:3 }}>グループ追加</Button>
                    <Button
                        size="small"
                        startIcon={<SaveAltIcon />}
                        color="success"
                        onClick={this.handleSortUpdate}
                        variant="contained"
                        style={{ float: "right", marginTop:3 }}>並び保存</Button>
                
                        <Dialog open={this.state.del_id > 0} 
                            // style={{zIndex:1052}} 
                            maxWidth="sm" fullWidth={true} onClose={(e) => { this.setState({ "del_id":0 });}}>
                              <DialogTitle>
                                削除してよろしいですか？
                                <IconButton
                                  aria-label="close"
                                  onClick={(e) => { this.setState({ "del_id":0 }); }}
                                  style={{float: 'right'}}
                                  size="large">
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>
                    
                              <DialogActions>
                                <Button variant="contained" style={{backgroundColor:"#e0e0e0", color:"black"}} onClick={(e) => { this.setState({ "del_id":0 });}}>キャンセル</Button>
                                <Button variant="contained" onClick={()=>{this.props.delete_m_calendar_groups(this.state.del_id);this.handleNewGroup();this.setState({ "del_id":0 });this.props.change_calendar_group_user_list([])}} style={{backgroundColor:"#dc3545", border:"#dc3545", color:"white"}} color="success">削除</Button>
                              </DialogActions>
                        </Dialog>

                </Box>
                <Box style={{width:"620px"}}>
                    <Box>
                        {/* {this.state.detail.id} */}
                        <TextField
                            id="name"
                            label="グループ名"
                            size="small"
                            variant="outlined"
                            onChange={this.handleChange}
                            name="name"
                            value={this.state.detail.name}
                            style={{ width: "300px" }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <FormControl style={{marginLeft:"20px"}}>
                            <FormGroup row>
                                <FormControlLabel control={<Checkbox checked={this.state.detail.is_default} value={this.state.detail.is_default} onChange={this.handleChange} name="is_default" />} label="初期表示" />
                            </FormGroup>
                        </FormControl>
                        
                        
                        <Button
                        size="small"
                        startIcon={<SaveAltIcon />}
                        onClick={this.handleUpdate}
                        color="success"
                        variant="contained"
                        style={{ marginRight: 5 }}>保存</Button>
                    </Box>
                    <Dialog open={this.state.showPopup}>
                        <DialogTitle>保存しました</DialogTitle>
                    </Dialog>


                    {this.state.detail.id && this.state.detail.id > 0 ? <Box display="flex" gap={2} style={{ustifyContent: 'center'}}>
                        <GroupSelectUser />

                        <Box style={{
                                      flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

                        }}>
                            {/* <span style={{fontSize:"40px"}}>←</span> */}
                            <ArrowBackIosIcon />
                        </Box>
                        <Box>



                            <FormControl size="small" style={{ width: "100%", marginTop:20 }}>
                                <InputLabel>部署を選択</InputLabel>
                                <Select
                                    id="section_id"
                                    name="section_id"
                                    onChange={this.handleChangeTenpo}
                                    value={this.state.section_id}
                                    label="部署を選択"
                                    // variant='standard'
                                >
                                    <MenuItem value={0}>全部署</MenuItem>
                                    {this.props.calendar_search_store_list && this.props.calendar_search_store_list.length > 0 ? this.props.calendar_search_store_list.map(function (item, i) {
                                        return (
                                            <MenuItem value={item.tenpo_no}>{item.tenpo_name}</MenuItem>
                                        );
                    
                                    }, this) : ""}
                                </Select>
                            </FormControl>

                            <div
                                style={{
                                border: '1px solid #ccc', // 外枠
                                width: 300,              // 必要に応じて幅指定
                                height: 418,          // 枠の高さ
                                display: 'flex',
                                flexDirection: 'column',
                                padding:0,
                                }}
                            >
                                <List
                                    style={{
                                        overflowY: 'auto',     // スクロールは内部のみ
                                        flex: 1,               // 枠いっぱいに伸ばす
                                        padding: 0,
                                        overflowX: 'hidden',
                                    }}
                                >
                                    {(this.state.section_id > 0 ? this.props.users.filter(a=>
                                    
                                        this.state.section_id == a.am_section_id || 

                (this.state.section_id == 501 ? a.section_group == 1 : "") ||
                (this.state.section_id == 502 ? a.section_group == 2 : "") ||
                (this.state.section_id == 503 ? a.section_group == 3 : "")
                                    ) : this.props.users).map((item) => (
                                        <ListItem 
                                        key={item.id}
                                        onClick={()=>this.onClickAddUser(item)}
                                        style = {{
                                            borderBottom: "1px solid #ddd",  // 下側だけの線
                                            padding: "0px 10px",
                                            marginBottom: "0px",
                                            backgroundColor: this.props.calendar_group_user_list.filter(a=>a.id == item.id).length > 0 ? "#dbd9d9ff": "",
                                            cursor: "move",
                                            listStyle: "none",
                                        }}
                                        >
                                            <ListItemText primary={item.user_name_all} />
                                        </ListItem>
                                    ))}
                                    
                                </List>
                    
                            </div>
                        </Box>
                    </Box>:""}

                    {/* <Box>
                        {this.state.detail.id && this.state.detail.id > 0?<Table
                            className="gridCalendarGroupList"
                            rowHeight={36}
                            rowsCount={this.props.calendar_group_user_list.length} 
                            width={250}
                            // height={150}
                            height={window.innerHeight - 450}
                            headerHeight={34}
                            onColumnResizeEndCallback={this._onColumnResizeEndCallbackUser}
                            isColumnResizing={false}
                            // rowClassNameGetter={this._rowClassNameGetter}
                            // onRowClick={this.RowClick}
                            
                        >
            
                            <Column width={this.state.columnWidthsUser.user_name_all} isResizable={true} columnKey="user_name_all" header={<Cell>氏名</Cell>} cell={({ rowIndex, ...props }) => (<Cell 
                                        // onClick={()=>this.handleCellClick(rowIndex)}
                                        draggable={true}
                                        onDragStart={() => this.dragStartUser(rowIndex)}
                                        onDragEnter={() => this.dragEnterUser(rowIndex)}
                                        onDragOver={(event) => event.preventDefault()}
                                        onDragEnd={() => this.dragEndUser()}
                                        className={rowIndex === this.state.setDragIndexUser ? 'dragging' : ''}
                            {...props}>
                                {this.props.calendar_group_user_list[rowIndex].user_name_all}
                            </Cell>)} />

                            <Column width={60} isResizable={false} header={<Cell>削除</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props}
                                                    // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                                                    draggable={true}
                                                    onDragStart={() => this.dragStartUser(rowIndex)}
                                                    onDragEnter={() => this.dragEnterUser(rowIndex)}
                                                    onDragOver={(event) => event.preventDefault()}
                                                    onDragEnd={() => this.dragEndUser()}
                                                    className={rowIndex === this.state.setDragIndexUser ? 'dragging' : ''}
                            >
                                <IconButton
                                onClick={(e)=>{this.setState({ "modal_del": true, "del_id":this.props.calendar_group_user_list[rowIndex].id })}}
                                style={{padding:2}}
                                size="large"><DeleteIcon /></IconButton>
                            </Cell>)} />
            
                        </Table>:""}
                    </Box> */}



                </Box>


            </Box>;
    }
}

const mapStateToProps = (state) => {
    return {

        calendar_group_list: state.calendar.calendar_group_list,
        calendar_group_user_list: state.calendar.calendar_group_user_list,
        users: state.calendar.users,
        calendar_search_store_list: state.calendar.calendar_search_store_list,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        get_calendar_group_list(state) {
            dispatch(CalendarSaga.get_calendar_group_list(state))
        },
        change_calendar_group_list(state) {
            dispatch(CalendarSaga.change_calendar_group_list(state))
        },
        get_calendar_group_user_list(state) {
            dispatch(CalendarSaga.get_calendar_group_user_list(state))
        },
        change_calendar_group_user_list(state) {
            dispatch(CalendarSaga.change_calendar_group_user_list(state))
        },
        insert_m_calendar_groups(state) {
            dispatch(CalendarSaga.insert_m_calendar_groups(state))
        },
        delete_m_calendar_groups(state) {
            dispatch(CalendarSaga.delete_m_calendar_groups(state))
        },
        update_m_calendar_groups(state) {
            dispatch(CalendarSaga.update_m_calendar_groups(state))
        },
        update_m_calendar_groups_sort(state) {
            dispatch(CalendarSaga.update_m_calendar_groups_sort(state))
        },
    };
} 

// export default AddressGrid;
export default connect(mapStateToProps, mapDispatchToProps)(GroupEdit);

